import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { AddRevenue } from '../../Redux/action/revenueAction';
import { allLocationWithShortName, dataUser, spocLocationDetailsZoho } from '../Helpers/util';
import './form.css';
import axios from 'axios';
import { getLocationNameById } from '../../utils/getLocationNameById';
import { toast } from 'react-toastify';
import moment from 'moment';
import SwTextArea from '../Common/FormComponent/SwTextArea';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";

let count = 0;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName()

class ManPowerRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      company_id: UserObj ? UserObj.company_id : null,
      spocid: UserObj ? UserObj.rec_id : null,
      email: UserObj ? UserObj.email : '',
      notes: '',
      func: [
        {
          manpower_type: '',
          req_type: '',
          start_date: '',
          end_date: '',
        },
      ],
      locationSpoc: [],
      location: '',
      location1: '',
      locationError: '',
      notesError: '',
      dynamicFieldError: false,
      locationData: [],
      locationNew: [],
      locationId: null,
      files: null,
      attachmentError: '',
      btnStatus: false,
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    };
  }
  // componentDidMount() {
  //   const params = {
  //     params: { spoc: UserObj?.rec_id, client: UserObj?.company_id },
  //   };
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
  //       params,
  //     )
  //     .then(res => {
  //       if (res.data.status == 'success') {
  //         this.setState({
  //           locationSpoc: res.data.data,
  //         });
  //       }
  //     });
  // }

  componentDidMount() {
    var LocationSpoc = JSON.parse(userDataLocal12);
    let locationShort = JSON.parse(locationWithShortName)
    this.setState({ locationNew: locationShort })
    this.setState({
      locationData: LocationSpoc,
    });
  }


  changeSelect = (e) => {
    if (!e) {
      this.setState({
        location: null,
        location1: "",
        locationId: "",
        locationError: "",
      });
      return;
    }

    this.setState({
      location: e,
      location1: String(e.label),
      locationId: e.value,
      locationError: "",
    });
  };

  onLocation = e => {
    this.setState({
      location: e?.target?.value,
      location1: String(e.value),
      locationError: '',
    });
  };
  onManpower = (e, i) => {
    let tempState = [...this.state.func];
    tempState[i]['manpower_type'] = e?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };
  onManType = (e, i) => {
    let tempState = [...this.state.func];
    tempState[i]['req_type'] = e?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
    this.state.func[i].start_date = ""
    this.state.func[i].end_date = ""
  };
  onStartDate = (e, i) => {
    let tempState = [...this.state.func];
    tempState[i]['start_date'] = e?.target?.value;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  // onEndDate = (e, i) => {
  //   let tempState = [...this.state.func];
  //   tempState[i]['end_date'] = e?.target?.value;
  //   this.setState({
  //     func: tempState,
  //     dynamicFieldError: false,
  //   });
  // };

  onEndDate = (e, i) => {
    const selectedEndDate = e?.target?.value;
    let tempState = [...this.state.func];
    const startDate = tempState[i]['start_date'];

    // Check if the start date is selected
    if (!startDate) {
      toast.error("Please select the Start Date first.");
      return;
    }

    // Validate that the end date is not earlier than the start date
    if (selectedEndDate < startDate) {
      toast.error("End Date cannot be earlier than Start Date.");
      return;
    }

    // Update the state if all validations pass
    tempState[i]['end_date'] = selectedEndDate;
    this.setState({
      func: tempState,
      dynamicFieldError: false,
    });
  };

  onNotes = e => {
    this.setState({
      notes: e?.target?.value,
      notesError: '',
    });
  };
  removeFormFields(i) {
    let formValues = this.state.func;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }
  resetValue = () => {
    this.setState({
      notes: '',
      location: '',
      func: [
        {
          manpower_type: '',
          req_type: '',
          start_date: '',
          end_date: '',
        },
      ],
      locationError: '',
      notesError: '',
      dynamicFieldError: false,
      attachmentError: '',
    });
    count = 0;
    this.setState({
      selectedFile: undefined,
      selectedFileName: undefined,
      imageSrc: undefined,
      value: ''
    })
  };


  handleFile(e) {

    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        selectedFileName: e.target.files[0].name,
        imageSrc: window.URL.createObjectURL(e.target.files[0]),
        value: e.target.value,
      });
    }

    // Getting the files from the input
    this.setState({ files: e.target.files });

    if (e.target.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
    }
    else if (e.target.files.length <= 2) {
      this.setState({ attachmentError: "" });
    }
  }


  onFormSubmit1 = e => {
    e.preventDefault();

    let files = this.state.files;
    let formData = new FormData();

    // Append files to formData
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append('file', files[i]);
      }
    }

    // Initialize error flags
    let dynamicFieldError = false;
    let dateValidationError = false;

    // Validate dynamic fields and date ranges
    this.state.func.forEach((item, index) => {
      // Check for empty fields
      if (!(item.manpower_type && item.req_type && item.start_date && item.end_date)) {
        dynamicFieldError = true;
      }

      // Validate date ranges
      if (item.start_date && item.end_date && item.end_date < item.start_date) {
        dateValidationError = true;
      }
    });

    // Handle validation errors
    if (this.state.location === null || this.state.location === '') {
      this.setState({ locationError: "Location can't be empty" });
      toast.error("Location can't be empty");
    } else if (dynamicFieldError) {
      this.setState({ dynamicFieldError: true });
      toast.error("Please fill out all required fields.");
    } else if (dateValidationError) {
      toast.error("End Date cannot be earlier than Start Date.");
    } else if (this.state.files != null && this.state.files.length > 2) {
      this.setState({ attachmentError: "Attachment can't be more than 2" });
      toast.error("Attachment can't be more than 2");
    } else {
      e.currentTarget.disabled = true;
      let param = {};
      let common_param = {
        company_id: this.state.company_id,
        spoc_id: this.state.spocid,
        email: this.state.email,
        company_name: UserObj.company_name,
        category: 'man_power',
        company_name: UserObj ? UserObj.company_name : null,
      };
      let body_param = {
        manpower: this.state.func,
        location_name: this.state.location1,
        notes: this.state.notes,
      };
      param.common_param = common_param;
      param.body_param = body_param;

      // AddRevenue(param, formData);
      // this.setState({
      //   btnStatus: false,
      // });
      // e.currentTarget.disabled = false
      AddRevenue(param, (success, message) => {
        if (success) {
          toast.success(message);
          this.resetValue();
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
        this.setState({ btnStatus: false });
        e.currentTarget.disabled = false;
      });
    }
  };
  render() {
    const selectLocationData = [];
    if (this.state.locationSpoc && this.state.locationSpoc.length > 0) {
      this.state.locationSpoc.map(item => {
        if (item.rec_id) {
          selectLocationData.push({
            value: item['location_name_zoho'],
            label: item['location_name_zoho'],
          });
        }
        // selectLocationIds.push(JSON.stringify(item['rec_id']))
      });
    }
    const options1 = [
      { value: 'house_keeping', label: 'Housekeeping' },
      { value: 'pantry', label: 'Pantry' },
      { value: 'office_boy', label: 'Office Boy' },
      { value: 'security', label: 'Security' },
    ];
    const options2 = [
      { value: 'permanent', label: 'Dedicated' },
      { value: 'temporary', label: 'Temporary' },
    ];
    const options3 = [
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
    ];
    return (
      <>

        <div className="row">
          {' '}
          <div className="col-md-12">
            {' '}
            <div className="col-md-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Location <span className="Required">*</span></label>{' '}
                <SwSelect
                  name="location"
                  onChange={this.changeSelect}
                  value={this.state.location}
                  options={this.state.locationData}
                  id="manpower-location-select"
                  isClearable={false}
                />
                <span className="SwTextDanger SwTextSmall">
                  {this.state.locationError}
                </span>
              </div>
            </div>
          </div>
        </div>{' '}
        {this.state.func.map((item, index) => {
          return (<div className='ManpowerFormSet'>
            <div className='col-md-12'>
              <div className="event1 row">
                {' '}
                <div className="col-md-6 pr-2">
                  {' '}
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Manpower Type <span className="Required">*</span></label>{' '}
                    <SwSelect
                      placeholder="Select"
                      options={options1}
                      allowClear={false}
                      key={`key-${index}`}
                      id={`manpower-type-${index}`}
                      value={options1.filter(
                        option =>
                          option.value === item.manpower_type,
                      )}
                      onChange={e => this.onManpower(e, index)}
                    />{' '}
                  </div>
                  {this.state.dynamicFieldError && !item.manpower_type && <span className="SwTextDanger SwTextSmall">
                    {"Item can't be Empty"}
                  </span>}
                </div>{' '}
                <div className="col-md-6 pl-2">
                  {' '}
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Service Type <span className="Required">*</span></label>{' '}
                    <SwSelect
                      placeholder="Select"
                      options={options2}
                      allowClear={false}
                      key={`key1-${index}`}
                      id={`manpower-service--type-${index}`}
                      value={options2.filter(
                        option => option.value === item.req_type,
                      )}
                      onChange={e => this.onManType(e, index)}
                    />{' '}
                  </div>
                  {this.state.dynamicFieldError && !item.req_type && <span className="SwTextDanger SwTextSmall">
                    {"Type can't be Empty"}
                  </span>}
                </div>{' '}
              </div>{' '}
              <div className="event row">
                {/* Start Date */}
                <div className="col-md-6 pr-2">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Start Date <span className="Required">*</span>
                    </label>

                    <AntDDatePicker
                      type="single"
                      allowClear={false}
                      format="DD/MM/YYYY"
                      value={item.start_date ? dayjs(item.start_date) : null}
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                      onChange={(date) => {
                        this.onStartDate(
                          { target: { value: date ? date.format("YYYY-MM-DD") : "" } },
                          index
                        );
                      }}
                    />
                  </div>

                  {this.state.dynamicFieldError && !item.start_date && (
                    <span className="SwTextDanger SwTextSmall">
                      {"Start Date can't be Empty"}
                    </span>
                  )}
                </div>

                {/* End Date */}
                <div className="col-md-6 pl-2">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      End Date <span className="Required">*</span>
                    </label>

                    <AntDDatePicker
                      type="single"
                      allowClear={false}
                      format="DD/MM/YYYY"
                      value={item.end_date ? dayjs(item.end_date) : null}
                      disabledDate={(current) => {
                        if (!item.start_date) return true;
                        return (
                          current &&
                          current < dayjs(item.start_date).add(30, "day").startOf("day")
                        );
                      }}
                      onChange={(date) => {
                        this.onEndDate(
                          { target: { value: date ? date.format("YYYY-MM-DD") : "" } },
                          index
                        );
                      }}
                    />
                  </div>

                  {this.state.dynamicFieldError && !item.end_date && (
                    <span className="SwTextDanger SwTextSmall">
                      {"End date can't be Empty"}
                    </span>
                  )}
                </div>
              </div>

              <div className=''>
                {index == 0 ? (
                  <div >
                    {' '}
                    <button
                      type="button"
                      style={count + 1 < options1.length ? { color: "#0571c4" } : { color: "#63b4f2" }}
                      className="pl-0 btn addMoreIcon flex"
                      onClick={() => {
                        let tempState = [...this.state.func];
                        tempState.push({
                          manpower_type: '',
                          req_type: '',
                          start_date: '',
                          end_date: '',
                        });
                        this.setState({
                          func: tempState,
                        });
                        {
                          count = count + 1;
                        }
                      }}
                      disabled={
                        count + 1 < options1.length ? false : true
                      }
                    >
                      {' '}
                      <span>
                        {' '}
                        <i class="bi bi-plus-circle-fill"></i>{' '}
                        Add More
                      </span>{' '}
                    </button>{' '}
                  </div>
                ) : (
                  <div className="">
                    {' '}
                    <button
                      type="button"
                      className="btn removeBtn1 pt-1"
                      onClick={() => {
                        this.removeFormFields(index);
                        {
                          count = count - 1;
                        }
                      }}
                    >
                      {' '}
                      <span className='SwTextDanger'>
                        <i class="bi bi-trash3-fill"></i>
                      </span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          );
        })}

        <div className='row'>
          <div className="col-md-12  mt-3">
            {' '}
            <div className="col-md-12">
              <div className="SwFormGroup">
                <label className="SwFormLabel">Notes</label>{' '}
                <SwTextArea
                  rows="4"
                  value={this.state.notes}
                  onChange={this.onNotes}
                  id="manpower-notes"
                />{' '}
              </div>
            </div>
          </div>{' '}
        </div>

        <div className='row'>
          <div className="col-md-12  mt-3">
            <div className="col-md-12">
              <p className='mt-4 d-flex align-items-center' >
                <i class="bi bi-info-circle-fill"></i>
                <span className='ms-2'>The deployment of manpower per shift will last for 9 hours.</span>
              </p>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default ManPowerRequest;
